import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'

export const AvailabilityLoading = ({ isLoading, children }) => isLoading ? (
  <div className='card-button col-12 m-0 mt-1 p-0'>
    <Button
      loading
      text='Carregando'
      className='btn-flat mx-auto py-half'
      role='button'
      value='Carregando'
      aria-label='Carregando pontuação'
    />
  </div>
) : children

AvailabilityLoading.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
}

AvailabilityLoading.defaultProps = {
  isLoading: true
}

export default AvailabilityLoading



// WEBPACK FOOTER //
// ./src/features/Availability/ProductCard/ProductAvailability/AvailabilityLoading.js